import { useMemo } from 'react';

import type { TCreditPurposeFormFields } from 'entities/creditForm';

import { AccordionHeaderParamsTexts } from './formatCreditPurposeDescription/AccordionHeaderParams.texts';
import { formatCreditPurposeDescription } from './formatCreditPurposeDescription/formatCreditPurposeDescription';

type THeaderParams = {
  title: string;
  icon: string;
  description: string;
};

type DefaultParams = Partial<Pick<THeaderParams, 'title' | 'description'>>;

export const useAccordionHeaderParams = (
  data: Nullable<TCreditPurposeFormFields>,
  defaultData: DefaultParams,
  isOpen: boolean,
) => {
  const {
    title = defaultData.title || AccordionHeaderParamsTexts.HeaderDefaultTitle,
    description = defaultData.description || AccordionHeaderParamsTexts.HeaderDefaultDescription,
  } = useMemo((): Partial<THeaderParams> => {
    if (!data || isOpen) {
      return {};
    }

    return {
      title: formatCreditPurposeDescription(data),
      description: data.purpose?.label,
    };
  }, [data, isOpen]);

  return [title, description] as const;
};
